import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-77">
      <div className="max-w-3xl mx-auto text-center" data-id="element-78">
        <div className="text-4xl sm:text-5xl mb-6" data-id="element-79">💡</div>

        <h2 className="text-3xl sm:text-4xl font-serif font-black text-text-main mb-6" data-id="element-80">
          Warum ist der Preis heute so niedrig?
        </h2>

        <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-81">
          Weil dies ein Einführungsangebot ist. Wir möchten, dass möglichst
          viele Sportlehrer das Paket testen, nutzen und weiterempfehlen. Der
          Preis kann nach der Einführungsphase steigen.
        </p>
      </div>
    </section>;
}